/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UnknownGameIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABN0lEQVR4nN2VvU7DQAzHMyFV0IkOrDDxDKiMGYDzB5WMHUR5jwI74R14E16AoRtjpW4wgARjN4quSivRfBCl14Ge5CG6v/07+y52FG3MEpEtZH0A0jdkmzYxYH1FttTHygH8RtPAmLc0B8joU2AbxPHVNpDe1D/5bx8fqyiDmVhEdmbfiO26gCKfUoA/hXdA1tvaGRT4lAIKjewFzi0WkRaA7CPbHZJOqnxqA4D1i7m/u6x3pP0gAGT9POtdHiBeXCPrB7A+L2rONg4AsGX7dr3kMHt5w9CAR8d64vWnIntV99AEMFpoEdvA9hToDix7STrxP5NzSQfJ3v/SNyoRsA6r6r4ygEiPHCfdtQEcJ10iPV4JEKLZYRVgbc0O5u06QLODknYdbOAA2X3JyLR0nknwkRn91/UD6GHDe66f98AAAAAASUVORK5CYII=)
 */
export const UnknownGameIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm6.81 7c-.54 0-1 .26-1.23.61A1 1 0 0 1 8.92 8.5 3.49 3.49 0 0 1 11.82 7c1.81 0 3.43 1.38 3.43 3.25 0 1.45-.98 2.61-2.27 3.06a1 1 0 0 1-1.96.37l-.19-1a1 1 0 0 1 .98-1.18c.87 0 1.44-.63 1.44-1.25S12.68 9 11.81 9ZM13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7-10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM18.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM7 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM5.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
